<ng-container [ngSwitch]="col?.formControlName">
  <span [ngClass]="{'has-color': workbookRow?.rowData?.[col?.id]?.color}"
    [style.background-color]="workbookRow?.rowData?.[col?.id]?.color || 'transparent'"
    [style.color]="workbookRow?.rowData?.[col.id]?.textColor || 'inherit'">

    <ng-container *ngSwitchCase="'DatePicker'">
      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'MM/DD/YYYY':false }}
    </ng-container>

    <ng-container *ngSwitchCase="'DateTimePicker'">
      {{ workbookRow?.rowData?.[col?.id]?.value | localDate:'dateTime':false }}
    </ng-container>

    <ng-container *ngSwitchCase="'Percentage'">
      {{ workbookRow?.rowData?.[col?.id]?.value }}<span *ngIf="workbookRow?.rowData?.[col?.id]?.value">%</span>
    </ng-container>

    <ng-container *ngSwitchCase="'URL'">
      <a [href]="workbookRow?.rowData?.[col?.id]?.value | url" target="_blank">
        {{ workbookRow?.rowData?.[col?.id]?.value }}
      </a>
    </ng-container>

    <ng-container *ngSwitchCase="'Phone'">
      {{ workbookRow?.rowData?.[col?.id]?.value | phoneNumber }}
    </ng-container>

    <ng-container *ngSwitchCase="'Currency'">
      {{ workbookRow?.rowData?.[col?.id]?.value | currencySymbol: null : col?.currencySymbol }}
    </ng-container>

    <ng-container *ngSwitchCase="'Multi-Line'">
      <span pTooltip="{{ workbookRow?.rowData?.[col?.id]?.value }}" tooltipPosition="top"
        style="white-space: pre-line;">
        {{ workbookRow?.rowData?.[col?.id]?.value | shorten }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'RichText'">
      <span pTooltip="{{ workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags }}" tooltipPosition="top">
        {{ workbookRow?.rowData?.[col?.id]?.value | removeHtmlTags | shorten }}
      </span>
    </ng-container>

    <ng-container *ngSwitchCase="'EncryptedText'">
      {{ workbookRow?.rowData?.[col?.id]?.value ? '******' : '' }}
    </ng-container>

    <ng-container *ngSwitchCase="'Time'">
      {{ workbookRow?.rowData?.[col?.id]?.value | onlyTime }}
    </ng-container>

    <ng-container *ngSwitchCase="'AutoNumber'">
      @if(workbookRow?.rowData?.[col?.id]?.value) {
      {{ (col?.prefix || '') + (workbookRow?.rowData?.[col?.id]?.value || '') }}
      }
    </ng-container>

    <ng-container *ngSwitchCase="'Decimal'">
      {{ workbookRow?.rowData?.[col?.id]?.value | number:'1.0-' + (col?.maxDecimalPlaces || 2) || '1.0-2' }}
    </ng-container>

    <ng-container *ngSwitchCase="'UserLookup'">
      @if(workbookRow?.rowData?.[col?.id]?.value?.UserId) {
      <span class="truncate pointer"
        (click)="openTaggedUserDetails($event, workbookRow?.rowData?.[col?.id]?.value?.UserId)">
        {{ workbookRow?.rowData?.[col?.id]?.value?.UserName }}
      </span>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'FileUpload'">
      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
        <div class="p-d-flex">
          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
            {{ workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25 }}
          </span>
          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
            (click)="openFiles($event, workbookRow?.rowData?.[col?.id]?.value)">
            ({{ workbookRow?.rowData?.[col?.id]?.value?.length }})
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'Picture'">
      <ng-container *ngIf="workbookRow?.rowData?.[col?.id]?.value">
        <div class="p-d-flex">
          <span [pTooltip]="workbookRow?.rowData?.[col?.id]?.value[0]?.fileName" tooltipPosition="top">
            {{ workbookRow?.rowData?.[col?.id]?.value[0]?.fileName | shorten:25 }}
          </span>
          <span *ngIf="workbookRow?.rowData?.[col?.id]?.value?.length" class="p-ml-2 pointer"
            (click)="openPics($event, workbookRow?.rowData?.[col?.id]?.value)">
            ({{ workbookRow?.rowData?.[col?.id]?.value?.length }})
          </span>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchDefault>
      {{ workbookRow?.rowData?.[col?.id]?.value }}
    </ng-container>

  </span>
</ng-container>

<ng-container *ngIf="displayUserDetails&&selectedUser">
  <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUser"
    (close)="closeTaggedUserDetails()"></user-details-modal>
</ng-container>

<!-- File viewer component -->
<app-file-viewer *ngIf="displayFileDialog"
    [displayDialog]="displayFileDialog"
    [displayType]="displayType"
    [displayItems]="displayItems"
    (displayDialogChange)="onDisplayDialogChange($event)">
</app-file-viewer>